export var REFRESH_TOKEN_KEY = 'refresh';
export var ACCESS_TOKEN_KEY = 'access';
export var ENCRYPTED_CREDENTIALS_PARAM = 'ac';
export var ENCRYPTED_CREDENTIALS_PRACTITIONER_PARAM = 'mk';
export var LOGIN_URL_SSO_TOKEN_KEY = 'login_url';
export var VISITANT_KEY = 'visitant';
